<template>
  <div class="w-100 h-100 position-fixed">
    <div class="center-self-absolute">
      <BSpinner />
    </div>
  </div>
</template>

<script setup lang="ts">
// simple presentational component; no reactive state required
import { BSpinner } from 'bootstrap-vue-next';
</script>

<style lang="scss" scoped>
@use "@/assets/scss/common/alignment" as *;
:deep(.spinner-border) {
  height: 24px;
  width: 24px;
  border-right-color: #4d8edc;
  color: #f0f0f0;
  border-width: 2px;
  margin-right: 10px;
}
</style>
